export enum UserGrades {
    GOLD = 0,
    SILVER = 1,
    BRONZE = 2,
    PLATINUM = 3
}
